<template>
	<div
		class="omapi-monsterleads__table"
		:class="{
			'omapi-monsterleads__refreshing': isRefreshing,
			'omapi-monsterleads__no-data': !hasLeads,
		}"
	>
		<monsterleads-search-button placeholder="Search Contacts..." />

		<div class="omapi-monsterleads__tablenav">
			<monsterleads-contacts-filters />
			<monsterleads-contacts-actions />
		</div>
		<table-base :headers="headers" :is-loading="false" class="omapi-table">
			<template v-if="hasLeads">
				<monsterleads-contacts-row v-for="lead in leads" :key="lead.id" :lead="lead" />
			</template>

			<template #no-data>No contacts.</template>
		</table-base>
		<div class="omapi-monsterleads__tablenav omapi-monsterleads__bottom">
			<monsterleads-contacts-bulk-actions />
			<monsterleads-table-pagination :page-total="leads.length" />
		</div>
		<monsterleads-modal-email-upsell />
		<monsterleads-modal-bulk-delete />
		<div v-for="lead in leads" :key="lead.id">
			<monsterleads-modal-show-lead :lead="lead" />
		</div>
	</div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
const { mapState } = createNamespacedHelpers('monsterleads');

export default {
	data() {
		return {
			selectedIndex: null,
			headers: [
				{ name: 'Contact Name', class: 'monsterleads-table-name' },
				{ name: 'Email', class: 'monsterleads-table-email' },
				{ name: 'Date', class: 'monsterleads-table-date' },
				{ name: '<span>Actions</span>', class: 'monsterleads-table-actions' },
			],
		};
	},
	computed: {
		...mapState(['leads']),
		hasLeads() {
			return 0 < Array.from(this.leads).length;
		},
		selectedLead() {
			return Array.from(this.leads)[this.selectedIndex];
		},
		isLoading() {
			return this.$store.getters.isLoading('monsterleads');
		},
		isRefreshing() {
			return this.isLoading && this.$store.getters.isFetched('monsterleads');
		},
	},
	watch: {
		selectedLead(newValue) {
			if (newValue) {
				this.$nextTick(() => this.$modal.show('show-lead-modal'));
			}
		},
	},
};
</script>

<style lang="scss">
@import '../../../assets/scss/variables';
.omapi-screen {
	.om-circle-loading {
		margin: 10px auto;
	}
	.omapi-monsterleads {
		&__table {
			.omapi-table {
				border: none;
				&.striped > tbody > :nth-child(odd) {
					background-color: $color_white-button-background;
				}
			}
			th {
				padding: 14px 10px;
				border-bottom-color: $color_grey-light;
				&.checkbox-cell {
					width: 12px;
					padding: 16px 13px;
				}
				&.monsterleads-table-name {
					width: 330px;
					@media screen and (max-width: 1455px) {
						width: 155px;
					}
				}
				&.monsterleads-table-email {
					width: 359px;
					@media screen and (max-width: 1455px) {
						width: 250px;
					}
				}
				&.monsterleads-table-date {
					width: 240px;
				}
				&.monsterleads-table-actions {
					width: 175px;
				}
			}
			td {
				padding: 13px 13px 12px 9px;
				&.om-table-cell-has-checkbox {
					padding: 16px 13px;
				}
				&.monsterleads-table-name {
					color: $color_black;
					font-weight: $font_bold;
					.row-actions {
						font-weight: 400;
					}
				}
				&.monsterleads-table-email {
					text-decoration: underline;
				}
			}
			tfoot th {
				padding: 8px 10px;
				border-top-color: $color_grey-separator;
				&.monsterleads-table {
					&-name {
						color: $font_secondary-color;
					}
					&-email,
					&-date,
					&-actions {
						color: $color_white;
					}
				}
			}
		}
		&__bottom {
			display: flex;
			justify-content: space-between;
			margin-top: 16px;
			align-items: center;
		}
		&__search-wrap {
			display: flex;
			justify-content: flex-end;
			margin: -74px -10px 32px 0;
			@media screen and (max-width: 1150px) {
				justify-content: flex-start;
				margin: 0 0 16px;
				input[type='search'].omapi-input__inline {
					margin-left: 0;
				}
			}
		}
		&__refreshing {
			opacity: 0.5;
			&.omapi-monsterleads__no-data {
				td {
					padding-top: 34px;
					padding-bottom: 33px;
				}
			}
		}
	}
}
// This along with the table min-width allows the full table to show on smaller screens
// by scrolling horizontally. The alternative is to probably hide some of the columns on
// smaller screens, which I'm not sure we want to do since we have functionality
// tied into each of the columns
@media screen and (max-width: 1145px) {
	.omapi-app-monsterleads #wpbody-content {
		overflow-x: scroll !important;
		.omapi-monsterleads__table {
			min-width: 945px;
			padding-right: 40px;
		}
	}
}
</style>
